// Wrapper function to delete a key of an object
const deleteKeyOfObject = (object, key) => {
    delete object[key];
}

export default deleteKeyOfObject;